import useProfilePersonalInfo from "hooks/useProfilePersonalInfo";
import { useTranslation } from "react-i18next";
import Avatar from "shared/Avatar/Avatar";
import ProfilePointHistory from "./ProfilePointHistory";
import ProfileEdit from "./ProfileEdit";
import Badge from "shared/Badge/Badge";
import VoucherList from "./VoucherList";

export default function ProfilePersonalInfo() {
  const { user, membership, vouchers, validVouchers, totalBookingHours, pointInfo, pointBalance, pointHistory } = useProfilePersonalInfo();

  const { t } = useTranslation();

  return (
    <div className=" w-full flex flex-col items-center text-center sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8">
      <Avatar imgUrl={user!["personal_image_url"]} hasChecked hasCheckedClass="w-6 h-6 -top-0.5 right-2" sizeClass="w-28 h-28" />
      {/* ---- */}
      <div className="space-y-3 text-center flex flex-col items-center">
        <h2 className="text-3xl font-semibold">
          {`${user!["first_name"] ? user!["first_name"] : ""} ${user!["last_name"] ? user!["last_name"] : ""}`}{" "}
          {user!["instagram_id"] && <span className="text-sm text-neutral-500 dark:text-neutral-400">@{user!["instagram_id"]}</span>}
        </h2>

        {user!["contact_email"] && <span className="text-sm text-neutral-500 dark:text-neutral-400">{user!["contact_email"]}</span>}
        {user!["contact_phone"] && <span className="text-sm text-neutral-500 dark:text-neutral-400">+852 {user!["contact_phone"]}</span>}
        {membership && <Badge color="yellow" name={membership?.name} />}
        {membership && membership?.is_enable_venue_discount ? <Badge color="green" name={`${membership?.discount} OFF`} /> : <></>}
        <div className="space-y-4">
          <div className="flex items-center space-x-4">
            <ProfileEdit />
          </div>
        </div>
      </div>

      {/* ---- */}
      <p className="text-neutral-500 dark:text-neutral-400">{t("profile_desc")}</p>

      {/* ---- */}
      <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>

      {/* ---- */}
      <div className="space-y-4">
        <div className="flex items-center space-x-4">
          <i className={`text-neutral-400 text-3xl las la-certificate`}></i>
          <span className="text-neutral-6000 dark:text-neutral-300">
            <span className="text-base font-semibold">{totalBookingHours}</span>
            {" " + t("profile_accumulate_hours")}
          </span>
        </div>

        <div className="flex items-center space-x-4">
          <i className={`text-neutral-400 text-3xl las la-credit-card`}></i>
          <span className="text-neutral-6000 dark:text-neutral-300">
            <span className="text-base font-semibold">{pointBalance}</span>
            {" " + (pointInfo?.point_name ?? "")}
          </span>
        </div>

        <div className="flex items-center space-x-4">
          <i className={`text-neutral-400 text-3xl las la-tags`}></i>
          <span className="text-neutral-6000 dark:text-neutral-300">
            <span className="text-base font-semibold">{validVouchers}</span>
            {" " + t("profile_voucher_total")}
          </span>
        </div>
      </div>

      <div className="space-y-4">
        <div className="flex items-center space-x-4">
          <ProfilePointHistory history={pointHistory} />
          <VoucherList vouchers={vouchers} />
        </div>
      </div>
    </div>
  );
}
